import { render, staticRenderFns } from "./InspectionEvents.vue?vue&type=template&id=633eb89e&"
import script from "./InspectionEvents.vue?vue&type=script&lang=js&"
export * from "./InspectionEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports